/* eslint-disable no-param-reassign */
import { combineReducers } from '@reduxjs/toolkit';

import advertisementsSlice from '@/components/advertisements/redux/slice';
import settingsOverviewSlice from '@/components/Map/WelcomeMessageAccordion/redux/slice';

const settingsSlice = combineReducers({
  [settingsOverviewSlice.name]: settingsOverviewSlice.reducer,
  [advertisementsSlice.name]: advertisementsSlice.reducer,
});

export type SettingsState = ReturnType<typeof settingsSlice>;

export default settingsSlice;
